const PlumberServicesData = [
  {
    id: 1,
    title: "Residential Plumbing Service",
    image: "/assets/PlumberServices/Plumber Services.jpg",
    image2: "/assets/PlumberServices/Plumber Services1.jpg",
    image3: "/assets/PlumberServices/Plumber Services2.jpg",
    shortDescription: "Expert plumbing solutions for your home.",
    description:
      "Our Residential Plumbing Service ensures your home’s plumbing systems run smoothly. From leak repairs to new installations, we provide comprehensive solutions.",
    description1:
      "We specialize in fixing leaks, unclogging drains, and installing fixtures like faucets, sinks, and water heaters. Our team uses advanced tools to ensure efficient repairs.",
    description2:
      "We prioritize customer satisfaction, providing reliable and hassle-free services to keep your home’s plumbing in excellent condition.",
    benefits: [
      "Reliable plumbing solutions for households.",
      "Skilled and certified plumbers.",
      "Quick response to emergencies.",
      "Affordable and transparent pricing.",
      "Long-lasting repairs and installations.",
      "Improved water flow and efficiency.",
    ],
  },
  {
    id: 2,
    title: "Commercial Plumbing Service",
    image: "/assets/PlumberServices/Commercial Plumbing Service.jpg",
    image2: "/assets/PlumberServices/Commercial Plumbing Service1.jpg",
    image3: "/assets/PlumberServices/Commercial Plumbing Service3.avif",
    shortDescription: "Efficient plumbing solutions for businesses.",
    description:
      "Our Commercial Plumbing Service is tailored to meet the needs of offices, retail spaces, and industrial facilities. We handle large-scale plumbing installations and repairs.",
    description1:
      "From pipeline maintenance to restroom installations, our team ensures smooth operations in commercial spaces. We also offer water supply optimization services.",
    description2:
      "Our plumbers are trained to work efficiently with minimal disruption to your business, ensuring a reliable plumbing system.",
    benefits: [
      "Custom plumbing solutions for businesses.",
      "Specialized in large-scale installations.",
      "Quick and efficient problem resolution.",
      "Minimizes operational downtime.",
      "Energy-efficient and eco-friendly plumbing options.",
      "Adheres to commercial safety standards.",
    ],
  },
  {
    id: 3,
    title: "Emergency Plumbing Service",
    image: "/assets/PlumberServices/Emergency Plumbing Service.jpg",
    image2: "/assets/PlumberServices/Emergency Plumbing Service1.jpg",
    image3: "/assets/PlumberServices/Emergency Plumbing Service2.jpg",
    shortDescription: "24/7 plumbing repairs for urgent issues.",
    description:
      "Our Emergency Plumbing Service provides immediate assistance for unexpected plumbing problems. Available 24/7, we respond quickly to minimize damage.",
    description1:
      "Whether it's a burst pipe, a clogged drain, or a leaking water heater, our team is equipped to handle emergencies efficiently and effectively.",
    description2:
      "We prioritize urgent situations and deliver fast, reliable solutions to restore your plumbing system to normal operation.",
    benefits: [
      "Available 24/7 for plumbing emergencies.",
      "Fast and efficient service to reduce damage.",
      "Experienced plumbers on call.",
      "Equipped to handle all types of emergencies.",
      "Affordable and transparent pricing.",
      "Minimizes downtime and inconvenience.",
    ],
  },
];

export default PlumberServicesData;
